"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useState } from "react";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.5;
  return <section id="hero" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[var(--duration-slow)] ease-linear" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/global_shipping_port_containers.png)",
      transform: `translateY(${parallaxOffset}px)`
    }} />

      {}
      <div className="absolute inset-0 bg-primary/60" />

      {}
      <div ref={ref} className="relative z-10 max-w-4xl mx-auto px-6 py-20 text-center">
        <h1 className={`font-display text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          International Sourcing & Commodity Trade
        </h1>

        <p className={`text-lg md:text-xl text-white/90 mb-10 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Reliable procurement, quality assurance, and logistics coordination
          for global buyers.
        </p>

        <div className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Button asChild className="btn-primary px-8 py-6 text-base font-semibold">
            <Link to="/ContactPage">Request a Quote</Link>
          </Button>

          <Button asChild variant="outline" className="px-8 py-6 text-base font-semibold bg-transparent border-2 border-white text-white hover:bg-white hover:text-primary transition-all duration-[var(--duration-fast)]">
            <Link to="/ProductsServicesPage">View Commodities</Link>
          </Button>
        </div>
      </div>
    </section>;
}